import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'

interface Props {
  currentLimit: number
  currentPage: number
  currentLength: number
  totalPages: number
  totalCount: number
  onPageChange: (page: number) => void
  onLimitChange: (limit: number) => void
}

const Pagination = ({
  currentLimit,
  currentPage,
  currentLength,
  totalCount,
  totalPages,
  onPageChange,
  onLimitChange,
}: Props): React.ReactElement => {
  const { t } = useTranslation('pagination')

  const showingFrom = useMemo(() => currentLimit * (currentPage - 1) + 1, [currentLimit, currentPage])
  const showingTo = useMemo(
    () => currentLimit * (currentPage - 1) + currentLength,
    [currentPage, currentLimit, currentLength]
  )

  const _onPageChange = (data: { selected: number }): void => {
    onPageChange(data.selected + 1)
  }

  const _onLimitChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    onLimitChange(parseInt(e.target.value, 10))
    onPageChange(1)
  }

  return (
    <div>
      <Row>
        <Col>
          {t('syniNidurstodur')} {showingFrom} - {showingTo} af {totalCount}
        </Col>
        <Col>
          <ReactPaginate
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            forcePage={currentPage - 1}
            containerClassName={`pagination justify-content-end pagination-sm`}
            pageClassName="page-item"
            pageLinkClassName="page-link cursor-pointer"
            activeClassName={'active'}
            previousClassName="page-item"
            previousLinkClassName="page-link cursor-pointer"
            nextClassName="page-item"
            nextLinkClassName="page-link cursor-pointer"
            disabledClassName="disabled"
            disableInitialCallback={true}
            onPageChange={_onPageChange}
            previousLabel={t('previous')}
            nextLabel={t('next')}
          />
        </Col>
      </Row>
      <div className="text-right small">
        {t('syna')}{' '}
        <select value={currentLimit} onChange={_onLimitChange}>
          <option value={1}>1</option>
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>{' '}
        {t('nidurstodurBls')}
      </div>
    </div>
  )
}

export default Pagination
